import type { FC, RefObject, ChangeEvent } from 'react';
import React from 'react';

interface HiddenInputForReceiptFileProps {
  onChangeFile: (e: ChangeEvent) => void;
  inputRef: RefObject<HTMLInputElement | null>;
}

export const HiddenInputForReceiptFile: FC<HiddenInputForReceiptFileProps> = ({
  onChangeFile,
  inputRef,
}) => {
  return (
    <input
      ref={inputRef}
      type="file"
      style={{ display: 'none' }}
      onChange={onChangeFile}
      accept="image/png, image/jpeg, image/jpg, .pdf"
    />
  );
};
